import { apiConstants } from '../types/apiTypes';

export const beginApiCall = () => ({
  type: apiConstants.BEGIN_API_CALL
});

export const endApiCall = () => ({
  type: apiConstants.END_API_CALL
});
